<div class="modal-overlay fixed inset-0" *ngIf="showAppointmentModal">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <div
    class="modal-container p-1 h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()"
  >
    <!-- Modal Header -->
    <div class="modal-header flex justify-between items-center">
      <h4 class="modal-title">{{ modalTitle }}</h4>
      <button class="close-btn text-3xl" (click)="closeModalHandler()">
        <span>&times;</span>
      </button>
    </div>

    <!-- Progress Steps -->
    <div class="booking-progress my-8">
      <div
        *ngFor="let step of bookingSteps"
        class="booking-progress__item"
        [class.booking-progress__item--active]="currentStep >= step.number"
      >
        <div class="booking-progress__step">{{ step.number }}</div>
        <span class="booking-progress__label">{{ step.label }}</span>
        <div
          *ngIf="step.number < bookingSteps.length"
          class="booking-progress__line"
        ></div>
      </div>
    </div>
    <!-- <div class="progress-steps">
      <div class="step" [class.active]="currentStep >= 1" [class.completed]="currentStep > 1">
        <div class="step-number">1</div>
        <span class="step-label">Date & Time</span>
      </div>
      <div class="step" [class.active]="currentStep >= 2" [class.completed]="currentStep > 2">
        <div class="step-number">2</div>
        <span class="step-label">Services</span>
      </div>
      <div class="step" [class.active]="currentStep >= 3" [class.completed]="currentStep > 3">
        <div class="step-number">3</div>
        <span class="step-label">Professional</span>
      </div>
      <div class="step" [class.active]="currentStep >= 4" [class.completed]="currentStep > 4" *ngIf="!isLoggedIn">
        <div class="step-number">4</div>
        <span class="step-label">Login</span>
      </div>
      <div class="step" [class.active]="currentStep >= (isLoggedIn ? 4 : 5)"
        [class.completed]="currentStep > (isLoggedIn ? 4 : 5)">
        <div class="step-number">{{isLoggedIn ? 4 : 5}}</div>
        <span class="step-label">Confirm</span>
      </div>
      <div class="step" [class.active]="currentStep >= (isLoggedIn ? 5 : 6)">
        <div class="step-number">{{isLoggedIn ? 5 : 6}}</div>
        <span class="step-label">Complete</span>
      </div>
    </div> -->
    <div
      *ngIf="currentStep === 1"
      class="tabs flex justify-start items-center px-7 mb-5"
    >
      <mat-tab-group
        class="custom-tabs-group"
        (selectedTabChange)="onTabChange($event)"
      >
        <mat-tab label="Featured" class="custom-tab"> </mat-tab>

        <mat-tab label="Hair" class="custom-tab"> </mat-tab>

        <mat-tab label="Esthetics" class="custom-tab"> </mat-tab>
        <mat-tab label="Nail" class="custom-tab"> </mat-tab>
      </mat-tab-group>
    </div>
    <!-- Modal Body -->
    <div class="modal-body !flex-1 !overflow-y-auto">
      <!-- Step 3: Date & Time Selection -->
      <div *ngIf="currentStep === 3" class="step-container">
        <div class="date-time-container">
          <div class="calendar-section text-center my-[1.5rem]">
            <h4 class="text-[20px] text-gray-950 mb-3">
              {{ startOfWeekDate | date: "MMMM, YYYY" }}
            </h4>
            <div
              class="relative calendar-grid flex justify-center items-center space-x-3"
            >
              <!-- Left Arrow -->
              <span class="mr-[1.5rem] cursor-pointer" (click)="prev()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </span>

              <div
                *ngFor="let date of currentWeekDays"
                class="date-item {{
                  checkIsDateValid(date)
                    ? 'cursor-pointer'
                    : 'cursor-not-allowed'
                }}"
              >
                <div
                  class="date-item {{
                    checkIsDateValid(date) ? '' : 'pointer-events-none'
                  }}"
                  [class.selected]="selectedDate === date"
                  (click)="selectDate(date)"
                >
                  <div
                    class="flex flex-col w-16  shadow self-start text-center  justify-center text-white rounded-lg mr-3 overflow-hidden {{
                      selectedDate === date
                        ? '!border-2 !border-[#7A5AF8]'
                        : '!border !border-gray-200'
                    }}"
                  >
                    <div
                      class="text-xs h-6 font-semibold text-gray-600 font-medium bg-gray-100 w-full flex items-center justify-center"
                    >
                      {{ date | date: "MMM" }}
                    </div>
                    <div
                      class="text-lg h-8 font-bold text-[#7A5AF8] flex items-center justify-center"
                    >
                      {{ date | date: "dd" }}
                    </div>
                  </div>
                  <!-- <span class="date-day">{{date | date:'EEE'}}</span>
                <span class="date-number">{{date | date:'d'}}</span> -->
                </div>
              </div>
              <!-- Right Arrow -->
              <span class="!ml-[1.5rem] cursor-pointer" (click)="next()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </span>
            </div>
          </div>

          <div class="time-section px-[9rem] my-[1.5rem]">
            <div
              *ngIf="!selectedDate"
              class="py-6 text-center text-sm text-gray-500"
            >
              Select a date to see {{ selectedStaff?.full_name }}'s
              availability.
            </div>

            <div *ngIf="selectedDate">
              <div
                *ngIf="loadingAvailability"
                class="mb-3 text-center text-sm text-gray-500"
              >
                Checking {{ selectedStaff?.full_name }}'s availability...
              </div>

              <div
                *ngIf="!loadingAvailability && !hasAvailableTimeSlots()"
                class="mb-3 text-center text-sm text-gray-500"
              >
                No times are available for {{ selectedStaff?.full_name }} on
                this day.
              </div>

              <div class="time-slots flex flex-wrap gap-3">
                <button
                  *ngFor="let time of availableTimeSlots"
                  type="button"
                  class="booking-time-slot shadow py-[0.5rem] font-medium px-1 w-[109.5px] text-md"
                  [class.booking-time-slot--available]="
                    time.available && selectedTime !== time.time
                  "
                  [class.booking-time-slot--selected]="
                    time.available && selectedTime === time.time
                  "
                  [class.booking-time-slot--unavailable]="!time.available"
                  [disabled]="!time.available || loadingAvailability"
                  (click)="selectTime(time.time)"
                >
                  {{ time.time }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 1: Services Selection -->
      <div *ngIf="currentStep === 1" class="step-container">
        <div class="services-list px-7">
          <div *ngFor="let service of filteredServices" class="mb-4">
            <div
              class="flex shadow w-full justify-between items-center  border  rounded-lg p-4 shadow-sm {{
                isServiceSelected(service.service_id)
                  ? 'border-[#7A5AF8] bg-purple-50'
                  : 'border-gray-200 text-white bg-white'
              }}"
            >
              <!-- Left: title + duration -->
              <div class="flex-1 pr-4 space-y-3">
                <!-- Title -->
                <h3 class="text-md font-medium text-gray-900 leading-5">
                  {{ service.name }}
                </h3>

                <!-- Duration -->
                <p class="text-xs text-gray-500 mt-1 leading-4">
                  {{ service.duration }}
                </p>
              </div>

              <!-- Right: price (top) + button (bottom) -->
              <div
                class="flex flex-col items-end justify-between ml-2 min-h-[56px]"
              >
                <!-- price -->
                <span class="text-sm text-gray-900 font-semibold pr-2">
                  {{ service.price | currency: "USD" : "symbol" : "1.2-2" }}
                </span>

                <!-- Add / Added button -->
                <button
                  (click)="toggleService(service)"
                  [attr.aria-pressed]="isServiceSelected(service.service_id)"
                  class="flex items-center gap-2 text-sm font-medium px-3 py-[5px] rounded-full transition-colors duration-150"
                  [ngClass]="
                    isServiceSelected(service.service_id)
                      ? 'border border-gray-200 bg-white text-gray-700 shadow-sm'
                      : 'bg-black text-white'
                  "
                >
                  <!-- check icon for Added -->
                  <svg
                    *ngIf="isServiceSelected(service.service_id)"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4 text-green-600"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>

                  <!-- plus icon for Add -->
                  <svg
                    *ngIf="!isServiceSelected(service.service_id)"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 4v16M4 12h16"
                    />
                  </svg>

                  <span
                    class="{{
                      !isServiceSelected(service.service_id) ? 'text-white' : ''
                    }} "
                    >{{
                      isServiceSelected(service.service_id) ? "Added" : "Add"
                    }}</span
                  >
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="selected-services-summary px-8"
          *ngIf="selectedServices.length > 0"
        >
          <h4 class="text-gray-950 font-medium">
            Selected Services:
            <span class="">({{ selectedServices.length }})</span>
          </h4>
          <div class="summary-total">
            <span class="text-gray-950 font-medium"
              >Total: <span class="">${{ getTotalPrice() }}</span></span
            >
          </div>
        </div>
      </div>

      <!-- Step 2: Professional Selection -->
      <div *ngIf="currentStep === 2" class="step-container px-7">
        <div class="grid grid-col-1 gap-3">
          <div
            *ngFor="let staffMember of staff"
            class="staff-card"
            [class.selected]="selectedStaff?.staff_id === staffMember.staff_id"
            (click)="selectStaff(staffMember)"
          >
            <div
              class="flex items-center justify-between rounded-xl border {{
                selectedStaff?.staff_id === staffMember.staff_id
                  ? 'border-purple-500 bg-purple-50'
                  : 'border-gray-200'
              }} px-4 py-3 shadow-sm "
            >
              <!-- Left -->
              <div class="flex items-center space-x-3">
                <img
                  [src]="assetUrl + 'img\avatar1.png'"
                  alt="Helen"
                  class="h-[52px] w-[52px] rounded-full object-cover"
                />
                <div class="grid grid-col-1 gap-y-1">
                  <p class="text-sm font-medium text-gray-900">
                    {{ staffMember?.full_name }}
                  </p>
                  <p class="text-sm text-gray-600">
                    {{ staffMember?.job_title }}
                  </p>
                </div>
              </div>

              <!-- Right -->
              <div class="flex items-center space-x-2">
                <div class="flex items-center space-x-1 text-gray-600">
                  <svg
                    class="h-5 w-5 fill-white stroke-[1] stroke-gray-950"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z"
                    />
                  </svg>
                  <span class="text-md font-medium">4.7</span>
                </div>
                <!-- Selected radio -->
                <span
                  class="inline-block h-5 w-5 rounded-full border {{
                    selectedStaff?.staff_id === staffMember.staff_id
                      ? 'border-[6px] border-[#6938EF]'
                      : 'border-2 border-gray-200'
                  }}  bg-white"
                ></span>
              </div>
            </div>
          </div>
          <glo-empty *ngIf="staff.length === 0" mode="staff"></glo-empty>
        </div>
      </div>

      <!-- Step 4: Account -->
      <div
        *ngIf="currentStep === 4"
        class="step-container px-7 flex flex-col justify-center items-center"
      >
        <div *ngIf="isLoggedIn && currentUser" class="booking-account-card">
          <div class="booking-account-card__icon">
            <mat-icon>account_circle</mat-icon>
          </div>

          <div class="booking-account-card__copy">
            <span class="booking-account-card__eyebrow">Signed in as</span>
            <h3>{{ currentUser.full_name || currentUser.email }}</h3>
            <p>{{ currentUser.email }}</p>
          </div>

          <div class="booking-account-card__actions">
            <button
              type="button"
              class="booking-account-card__continue"
              (click)="continueWithCurrentUser()"
            >
              Continue as {{ currentUser.full_name || currentUser.email }}
            </button>

            <button
              type="button"
              class="booking-account-card__switch"
              [disabled]="isLoading"
              (click)="signOutAndSwitchAccount()"
            >
              Sign out and use a different account
            </button>
          </div>
        </div>

        <div *ngIf="!isLoggedIn" class="booking-auth-shell">
          <customer-login
            *ngIf="bookingAuthView === 'login'"
            class="w-full"
            [LoginFromModal]="true"
            [initialEmail]="bookingAuthEmail"
            (otpRequested)="onBookingOtpRequested($event)"
            (registerRequested)="showBookingSignup($event)"
          ></customer-login>

          <customer-sign-up
            *ngIf="bookingAuthView === 'signup'"
            class="w-full"
            [SignUpFromModal]="true"
            [initialEmail]="bookingAuthEmail"
            (accountCreated)="onBookingAccountCreated($event)"
            (otpRequested)="onBookingOtpRequested($event)"
            (loginRequested)="showBookingLogin($event)"
          ></customer-sign-up>

          <app-verify-otp
            *ngIf="bookingAuthView === 'otp'"
            class="w-full"
            [OtpFromModal]="true"
            [modalEmail]="bookingAuthEmail"
            (verified)="onBookingOtpVerified()"
            (backToLogin)="showBookingLogin(bookingAuthEmail)"
          ></app-verify-otp>
        </div>
      </div>

      <!-- Step 5: Confirmation -->

      <div
        *ngIf="currentStep === 5"
        class="step-container flex flex-col justify-center items-center"
      >
        <!-- Container -->

        <div class="space-y-6">
          <div class="overflow-hidden">
            <!-- Header row -->
            <div
              class="flex items-start justify-between gap-4 h-[160px] rounded-2xl border border-2 border-gray-200 p-[12px]"
            >
              <!-- Left: venue image -->
              <div class="flex items-start gap-4">
                <img
                  [src]="assetUrl + 'img/mock-salon1.png'"
                  alt="Studio"
                  class="w-[191px] h-[136px] rounded-lg object-cover border border-gray-100 shadow-sm"
                />

                <!-- Title & meta -->
                <div class="grid grid-col-1 gap-y-2">
                  <h2 class="text-base font-semibold text-gray-900">
                    {{ salonData?.name }}
                  </h2>

                  <div
                    class="mt-1 flex items-center gap-3 text-xs text-gray-500"
                  >
                    <!-- rating -->
                    <div class="flex items-center gap-1">
                      <svg
                        class="w-4 h-4 text-yellow-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z"
                        />
                      </svg>
                      <span class="text-sm text-gray-700">4.7</span>
                      <span class="text-gray-400">•</span>
                      <span class="text-sm">138 Reviews</span>
                    </div>
                  </div>

                  <!-- distance & address -->
                  <div class="flex items-center gap-1">
                    <svg
                      class="w-[16px] h-[16px] text-gray-900 bg-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        d="M12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 2C8.134 2 5 6.418 5 10.5c0 3.81 5.293 9.48 6.083 10.33.41.43 1.14.43 1.55 0C13.707 19.98 19 14.31 19 10.5 19 6.418 15.866 2 12 2z"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="text-sm"
                      >{{ salonData?.address }}, {{ salonData?.city }}</span
                    >
                  </div>

                  <!-- provider small row -->
                  <div
                    class="mt-1 p-[4px_12px_4px_4px] w-fit max-w-full h-[40px] flex items-center gap-3 border border-2 border-gray-300 rounded-3xl"
                  >
                    <img
                      src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=40&auto=format&fit=crop"
                      alt="Helen"
                      class="w-[32px] h-[32px] rounded-full object-cover border border-gray-100"
                    />
                    <div class="text-xs text-gray-600 leading-4">
                      <div class="text-gray-800 font-medium">
                        Service by Helen
                      </div>
                      <div class="text-gray-400">Monica's appointment</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Date and time row + promo -->
            <div class="mt-3 grid gap-5">
              <!-- Date/time card -->
              <div class="grid-col-1 space-y-3 p-2">
                <!-- date/time text -->
                <div class="flex justify-start items-center gap-1">
                  <svg
                    class="w-[19px] stroke-gray-950"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <rect
                      x="3"
                      y="5"
                      width="18"
                      height="16"
                      rx="2"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 3v4M8 3v4"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3 11h18"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div class="text-sm text-gray-600">
                    {{ formatedSelectedDate }}
                  </div>
                </div>
                <div class="flex justify-start items-center gap-1">
                  <svg
                    class="w-[19px] stroke-gray-950"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 7v5l3 2"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div class="text-sm text-gray-600">
                    {{ selectedTime }} (2 hours duration)
                  </div>
                </div>
              </div>

              <!-- Promo input -->
              <div class="border border-gray-200 rounded-[12px] shadow-sm p-3">
                <div
                  class="flex flex-col gap-3 md:flex-row md:justify-between md:items-center"
                >
                  <div class="flex justify-start items-center space-x-2 p-2">
                    <div
                      class="flex justify-center items-center bg-[#EBE9FE] rounded-full w-8 h-8"
                    >
                      <svg
                        class="stroke-[#5925DC] bg-purple-100 rounded-full"
                        fill="#000000"
                        width="20px"
                        height="20px"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="coupon">
                          <path
                            d="M21,10a2.2489,2.2489,0,0,1,.4087.0415.5072.5072,0,0,0,.4111-.1074A.4992.4992,0,0,0,22,9.55V7.5A2.503,2.503,0,0,0,19.5,5H4.5A2.503,2.503,0,0,0,2,7.5V9.55a.5.5,0,0,0,.5913.4917A2.2489,2.2489,0,0,1,3,10a2,2,0,0,1,0,4,2.2489,2.2489,0,0,1-.4087-.0415.5073.5073,0,0,0-.4111.1074A.4992.4992,0,0,0,2,14.45V16.5A2.503,2.503,0,0,0,4.5,19h15A2.503,2.503,0,0,0,22,16.5V14.45a.4992.4992,0,0,0-.18-.3843.5081.5081,0,0,0-.4111-.1074A2.2489,2.2489,0,0,1,21,14a2,2,0,0,1,0-4Zm0,5v1.5A1.5017,1.5017,0,0,1,19.5,18H4.5A1.5017,1.5017,0,0,1,3,16.5V15A3,3,0,0,0,3,9V7.5A1.5017,1.5017,0,0,0,4.5,6h15A1.5017,1.5017,0,0,1,21,7.5V9a3,3,0,0,0,0,6Z"
                          />
                          <path
                            d="M12.5,9v1a.5.5,0,0,1-1,0V9a.5.5,0,0,1,1,0Z"
                          />
                          <path
                            d="M12.5,14v1a.5.5,0,0,1-1,0V14a.5.5,0,0,1,1,0Z"
                          />
                        </g>
                      </svg>
                    </div>

                    <label class="block text-md font-medium text-gray-900">
                      Have a promo code?
                    </label>
                  </div>

                  <div class="flex justify-end items-center space-x-2">
                    <input
                      type="text"
                      name="promo_code"
                      [(ngModel)]="promoCode"
                      (ngModelChange)="onPromoCodeChanged()"
                      (keyup.enter)="applyPromoCode()"
                      placeholder="Enter promo code"
                      autocomplete="off"
                      class="justify-self-end flex-1 rounded-3xl border border-gray-200 bg-white px-3 py-2 text-sm uppercase focus:outline-none focus:ring-2 focus:ring-purple-200"
                    />

                    <button
                      type="button"
                      class="justify-self-end rounded-full bg-white border border-gray-300 text-dark text-md font-semibold px-5 py-2 disabled:cursor-not-allowed disabled:opacity-50"
                      [disabled]="promoApplying || !promoCode.trim()"
                      (click)="applyPromoCode()"
                    >
                      {{ promoApplying ? "Applying..." : "Apply" }}
                    </button>
                  </div>
                </div>

                <p
                  *ngIf="promoError"
                  class="mt-2 px-2 text-xs font-medium text-red-600"
                >
                  {{ promoError }}
                </p>

                <div
                  *ngIf="appliedPromotion"
                  class="mt-3 flex items-center justify-between gap-3 rounded-xl border border-green-200 bg-green-50 px-3 py-2"
                >
                  <div>
                    <p class="text-xs font-semibold text-green-700">
                      {{ appliedPromotion.code }} applied
                    </p>

                    <p class="text-xs text-green-600">
                      {{ getPromotionDescription() }}
                    </p>
                  </div>

                  <button
                    type="button"
                    class="text-xs font-semibold text-gray-600 hover:text-gray-900"
                    (click)="removePromoCode()"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
            <!-- Services list -->
            <div class="mt-6 bg-white">
              <div class="overflow-hidden">
                <div class="p-[0px_0px_24px_8px]">
                  <h3 class="text-md font-medium text-gray-900">Services</h3>
                </div>

                <div
                  class="divide-y divide-gray-100 min-h-[196px] h-auto rounded-lg border border-gray-200 bg-gray-50 overflow-visible"
                >
                  <div
                    class="servicesList max-h-[142px] overflow-y-auto px-4 py-3"
                  >
                    <div
                      *ngFor="let service of selectedServices"
                      class="flex items-center justify-between py-3"
                    >
                      <div>
                        <div class="text-sm font-medium text-gray-900">
                          {{ service?.name }}
                        </div>
                        <div class="text-xs text-gray-500 mt-1">
                          1 hr, 30 mins
                        </div>
                      </div>
                      <div class="text-sm font-medium text-gray-800">
                        {{ service?.price }}
                      </div>
                    </div>

                    <!-- service row -->
                    <!-- <div class="flex items-center justify-between py-3">
                      <div>
                        <div class="text-sm font-medium text-gray-900">Coloring</div>
                        <div class="text-xs text-gray-500 mt-1">1 hr, 30 mins</div>
                      </div>
                      <div class="text-sm font-medium text-gray-800">$15.00</div>
                    </div> -->
                  </div>
                  <!-- pricing summary -->
                  <div
                    *ngIf="appliedPromotion"
                    class="px-4 py-3 border-t border-gray-100 bg-white space-y-2"
                  >
                    <div class="flex items-center justify-between">
                      <div class="text-sm text-gray-600">Subtotal</div>
                      <div class="text-sm text-gray-700">
                        ${{ getSubtotalPrice() }}
                      </div>
                    </div>

                    <div class="flex items-center justify-between">
                      <div class="text-sm font-medium text-green-700">
                        Promo {{ appliedPromotion.code }}
                      </div>
                      <div class="text-sm font-semibold text-green-700">
                        -${{ discountAmount.toFixed(2) }}
                      </div>
                    </div>
                  </div>

                  <!-- total row -->
                  <div
                    class="px-4 py-3 bg-gray-50 flex items-center justify-between"
                  >
                    <div class="text-md font-semibold text-gray-900">Total</div>
                    <div class="text-sm font-semibold text-gray-900">
                      ${{ getTotalPrice() }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /main card -->

          <!-- Payment form card -->
          <div class="p-4">
            <div class="w-full flex justify-between items-center">
              <h3 class="text-md font-medium text-gray-900 mb-6">Payment</h3>
            </div>

            <div
              *ngIf="paymentErrorMessage"
              class="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3"
            >
              <p class="text-sm text-red-600">{{ paymentErrorMessage }}</p>
            </div>

            <form class="space-y-4">
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >First name</label
                  >
                  <input
                    type="text"
                    [(ngModel)]="paymentForm.first_name"
                    name="payment_first_name"
                    placeholder="First name"
                    class="w-full rounded-3xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-200"
                  />
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >Last name</label
                  >
                  <input
                    type="text"
                    [(ngModel)]="paymentForm.last_name"
                    name="payment_last_name"
                    placeholder="Last name"
                    class="w-full rounded-3xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-200"
                  />
                </div>
              </div>

              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >Email</label
                  >
                  <input
                    type="email"
                    [(ngModel)]="paymentForm.email"
                    name="payment_email"
                    placeholder="e.g. john@gmail.com"
                    class="w-full rounded-3xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-200"
                  />
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >Phone number</label
                  >
                  <input
                    type="tel"
                    [(ngModel)]="paymentForm.phone"
                    name="payment_phone"
                    placeholder="+1 (555) 000-0000"
                    class="w-full rounded-3xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-200"
                  />
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2"
                  >Card Details</label
                >

                <div
                  class="rounded-2xl border border-gray-200 bg-white px-4 py-3"
                >
                  <div id="square-booking-card-container"></div>
                </div>

                <p class="mt-2 text-xs text-gray-500">
                  Your card details are securely handled by Square. We do not
                  store your full card number.
                </p>

                <span class="text-red-500 text-sm" *ngIf="!squareCardReady">
                  Please enter valid card details.
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Step 6: Success -->
      <div *ngIf="currentStep === 6" class="step-container success-container">
        <div class="success-icon flex justify-center items-center">
          <div
            class="bg-[#EBE9FE] w-20 h-20 rounded-full flex justify-center items-center"
          >
            <svg
              stroke="#5925DC"
              width="40px"
              height="40px"
              viewBox="0 0 24 24"
              fill="#EBE9FE"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                stroke="#5925DC"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.75 12L10.58 14.83L16.25 9.17004"
                stroke="#5925DC"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <h3 class="success-title text-xl font-medium text-center">
          Your booking is confirmed! 🎉
        </h3>
        <p class="success-message text-sm text-center">
          We've saved your spot! Can't wait to pamper you at
          <span class="text-sm font-bold">{{ salonData?.name }}</span>
        </p>
        <!-- Main card: service summary -->
        <div class="overflow-hidden">
          <!-- Header row -->
          <div
            class="flex items-start justify-between gap-4 h-[160px] rounded-2xl border border-2 border-gray-200 p-[12px]"
          >
            <!-- Left: venue image -->
            <div class="flex items-start gap-4">
              <img
                [src]="assetUrl + 'img/mock-salon1.png'"
                alt="Studio"
                class="w-[191px] h-[136px] rounded-lg object-cover border border-gray-100 shadow-sm"
              />

              <!-- Title & meta -->
              <div class="grid grid-col-1 gap-y-2">
                <h2 class="text-base font-semibold text-gray-900">
                  {{ salonData?.name }}
                </h2>

                <div class="mt-1 flex items-center gap-3 text-xs text-gray-500">
                  <!-- rating -->
                  <div class="flex items-center gap-1">
                    <svg
                      class="w-4 h-4 text-yellow-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z"
                      />
                    </svg>
                    <span class="text-sm text-gray-700">4.7</span>
                    <span class="text-gray-400">•</span>
                    <span class="text-sm">138 Reviews</span>
                  </div>
                </div>

                <!-- distance & address -->
                <div class="flex items-center gap-1">
                  <svg
                    class="w-[16px] h-[16px] text-gray-900 bg-white"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      d="M12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 2C8.134 2 5 6.418 5 10.5c0 3.81 5.293 9.48 6.083 10.33.41.43 1.14.43 1.55 0C13.707 19.98 19 14.31 19 10.5 19 6.418 15.866 2 12 2z"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="text-sm"
                    >{{ salonData?.address }}, {{ salonData?.city }}</span
                  >
                </div>

                <!-- provider small row -->
                <div
                  class="mt-1 p-[4px_12px_4px_4px] w-fit max-w-full h-[40px] flex items-center gap-3 border border-2 border-gray-300 rounded-3xl"
                >
                  <img
                    src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=40&auto=format&fit=crop"
                    alt="Helen"
                    class="w-[32px] h-[32px] rounded-full object-cover border border-gray-100"
                  />
                  <div class="text-xs text-gray-600 leading-4">
                    <div class="text-gray-800 font-medium">
                      Service by Helen
                    </div>
                    <div class="text-gray-400">Monica's appointment</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Date and time-->
          <div class="mt-3 grid gap-5">
            <div class="grid-col-1 space-y-3 p-2">
              <div class="flex justify-start items-center gap-1">
                <svg
                  class="w-[19px] stroke-gray-950"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <rect
                    x="3"
                    y="5"
                    width="18"
                    height="16"
                    rx="2"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 3v4M8 3v4"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 11h18"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="text-sm text-gray-600">
                  {{ formatedSelectedDate }}
                </div>
              </div>
              <div class="flex justify-start items-center gap-1">
                <svg
                  class="w-[19px] stroke-gray-950"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 7v5l3 2"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="text-sm text-gray-600">
                  {{ selectedTime }} (2 hours duration)
                </div>
              </div>
            </div>
          </div>

          <!-- Services list -->

          <div class="mt-6 bg-white">
            <div class="overflow-hidden">
              <div class="p-[0px_0px_24px_8px] text-start">
                <h3 class="text-md font-medium text-gray-900">Services</h3>
              </div>

              <div
                class="divide-y divide-gray-100 h-[196px] rounded-lg border border-gray-200 bg-gray-50"
              >
                <!-- service row -->
                <div class="servicesList overflow-y-auto h-[142px] px-4">
                  <div
                    *ngFor="let service of selectedServices"
                    class="flex items-center justify-between py-3"
                  >
                    <div>
                      <div class="text-sm font-medium text-gray-900">
                        {{ service?.name }}
                      </div>
                      <div class="text-xs text-gray-500 mt-1">
                        1 hr, 30 mins
                      </div>
                    </div>
                    <div class="text-sm font-medium text-gray-800">
                      ${{ service?.price }}
                    </div>
                  </div>

                  <!-- service row -->
                  <!-- <div class="flex items-center justify-between py-3">
                    <div>
                      <div class="text-sm font-medium text-gray-900">Coloring</div>
                      <div class="text-xs text-gray-500 mt-1">1 hr, 30 mins</div>
                    </div>
                    <div class="text-sm font-medium text-gray-800">$15.00</div>
                  </div> -->
                </div>
                <!-- total row -->
                <div
                  class="px-4 py-3 bg-gray-50 flex items-center justify-between"
                >
                  <div class="text-md font-semibold text-gray-900">Total</div>
                  <div class="text-sm font-semibold text-gray-900">
                    ${{ getTotalPrice() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /main card -->
        <!-- <div class="booking-details">
          <h4>Booking Summary</h4>
          <p><strong>Date:</strong> {{selectedDate | date:'fullDate'}}</p>
          <p><strong>Time:</strong> {{selectedTime}}</p>
          <p><strong>Professional:</strong> {{selectedStaff?.name}}</p>
          <p><strong>Total:</strong> ${{getTotalPrice()}}</p>
        </div> -->
      </div>

      <!-- <div *ngIf="currentStep === 6" class="step-container success-container">
        <div class="success-icon">
          <div class="checkmark">✓</div>
        </div>

        <h3 class="success-title">Booking Confirmed!</h3>
        <p class="success-message">
          Your appointment has been successfully booked. We've sent a confirmation email with all the details.
        </p>

        <div class="booking-details">
          <h4>Booking Summary</h4>
          <p><strong>Date:</strong> {{selectedDate | date:'fullDate'}}</p>
          <p><strong>Time:</strong> {{selectedTime}}</p>
          <p><strong>Professional:</strong> {{selectedStaff?.full_name}}</p>
          <p><strong>Total:</strong> ${{getTotalPrice()}}</p>
        </div>
      </div> -->
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer flex !justify-end gap-5" *ngIf="currentStep <= 6">
      <button
        class="btn bg-white !border !border-1 !border-gray-300 !rounded-3xl text-md font-semibold"
        *ngIf="currentStep > 1 && currentStep < 6"
        (click)="previousStep()"
      >
        Back
      </button>

      <button
        class="btn !rounded-3xl text-white {{
          !validateCurrentStep()
            ? '!cursor-not-allowed bg-gray-500'
            : 'bg-gray-950'
        }}"
        *ngIf="currentStep < 4"
        [disabled]="!validateCurrentStep()"
        (click)="nextStep()"
      >
        Next
      </button>

      <button
        class="btn bg-gray-950 !rounded-3xl confirm-btn"
        *ngIf="currentStep === 5"
        [disabled]="isLoading"
        (click)="confirmAppointment()"
      >
        <span *ngIf="!isLoading" class="!text-white">Confirm Appointment</span>
        <span *ngIf="isLoading" class="loading-text !text-white">
          <span class="spinner"></span>
          Confirming...
        </span>
      </button>

      <button
        class="btn bg-gray-950 !rounded-3xl confirm-btn"
        *ngIf="currentStep === 6"
        [disabled]="isLoading"
        (click)="GoToDashboard()"
      >
        <span class="!text-white text-md font-medium">Go to dashboard</span>
      </button>
    </div>
  </div>
</div>
